export const SITE_GROUP_DATA_LOADING = 'SITE_GROUP_DATA_LOADING';
export const SITE_GROUP_DATA_LIST_ERROR = 'SITE_GROUP_DATA_LIST_ERROR';
export const SITE_GROUP_DATA_LIST = 'SITE_GROUP_DATA_LIST';
export const WAREHOUSE_KITCHEN_DATA_LIST = 'WAREHOUSE_KITCHEN_DATA_LIST';
export const WAREHOUSE_KITCHEN_DATA_ERROR = 'WAREHOUSE_KITCHEN_DATA_ERROR';
export const OPEN_ORDER_DETAIL_DATA = 'OPEN_ORDER_DETAIL_DATA';
export const ITEM_DATA_LIST = 'ITEM_DATA_LIST';
export const OPEN_ORDER_CHECKALL_DATA = 'OPEN_ORDER_CHECKALL_DATA';
export const OPEN_ORDER_UPDATE_DATA = 'OPEN_ORDER_UPDATE_DATA';
export const OPEN_ORDER_UPDATE_DETAIL_SUBMIT =
  'OPEN_ORDER_UPDATE_DETAIL_SUBMIT';
export const OPEN_ORDER_UPDATE_DETAIL_ERROR = 'OPEN_ORDER_UPDATE_DETAIL_ERROR';
export const CHANGE_ROW_VALUE = 'CHANGE_ROW_VALUE';
export const OPEN_ORDER_DETAIL_DATA_ERROR = 'OPEN_ORDER_DETAIL_DATA_ERROR';
export const OPEN_ORDER_DATA_LOADING = 'OPEN_ORDER_DATA_LOADING';
export const ITEM_DATA_LOADING = 'ITEM_DATA_LOADING';
export const ITEM_DATA_ERROR = 'ITEM_DATA_ERROR';
export const SUBMITTING_OPEN_ORDER_LOADING = 'SUBMITTING_OPEN_ORDER_LOADING';
export const CLEAR_RUNNING_TOTAL = 'CLEAR_RUNNING_TOTAL';
export const CALCULATE_REMAINING_QTY = 'CALCULATE_REMAINING_QTY';
export const SET_SHOW_FLAG = 'SET_SHOW_FLAG';
export const SET_REMAINING_VALUE = 'SET_REMAINING_VALUE';
export const CLEAR_OPEN_ORDER_ERROR = 'CLEAR_OPEN_ORDER_ERROR';



// WEBPACK FOOTER //
// ./src/pages/utilities/state/updateopenorders/types.js